var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":_vm.item.src}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.item.title)))]),_vm._v(" "),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(_vm.$t(_vm.item.detail)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f2ad4fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SolutionItem.vue
// module id = null
// module chunks = 